import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from './CategoriesEditor.module.scss'
import { immutableArrayToggleItem, sortNumberArray } from "../../../../../../../helpers/common";
import Button from "../../../../../../../components/ripple/Button";

function CategoriesEditor({
                              value,
                              onChange,
                              // bodyBuilder,
                              suggestions,
                              title
                          }) {

    const [storedValue, setStoredValue] = useState(value);

    useEffect(() => setStoredValue(value), [value]);

    const isPortLocked = port => (storedValue?.some(p => p === port));

    const handleChange = item => {
        let newValue = immutableArrayToggleItem(item, storedValue);
        newValue = sortNumberArray(newValue);
        onChange(newValue);
        setStoredValue(newValue)
    }

    const renderBlock = (title, content) => {
        return (
            <div className={styles['editor__block']}>
                <p className={styles['editor__block__title']}>{title}</p>
                <div className={styles['editor__block__items']}>{content}</div>
            </div>
        )
    }

    const renderEmpty = () => <p className={styles.empty}>- No items found -</p>;

    const renderSelected = () => {

        if (!storedValue?.length) return renderEmpty();

        return storedValue.map((item, index) => {
            return (
                <div className={styles['editor__block__items__item']} key={index}>
                    <Button
                        title={item?.title || item?.code || item}
                        type='button'
                        onClick={() => setTimeout(() => handleChange(item), 200)}
                        iconRight='fas fa-times-circle'
                        visuals={{
                            borderRadius: '1.6rem',
                            height: '3.2rem',
                        }}
                    />
                </div>
            )
        })
    }

    const renderSuggestions = () => {

        if (!suggestions?.length) return null;

        let filtered = suggestions?.filter(port => !storedValue.includes(port));
        filtered = sortNumberArray(filtered);

        if (!filtered.length) return renderEmpty();

        return filtered.map((option, index) => {
            return (
                <div className={styles['editor__block__items__item']} key={index}>
                    <Button
                        title={option?.title || option?.code || option}
                        type='button'
                        displayType={'outlined'}
                        onClick={() => setTimeout(() => handleChange(option), 200)}
                        visuals={{
                            colorFont: ['var(--colorFontCommon)'],
                            colorRippleTint: ['var(--colorFontLight)'],
                            borderRadius: '1.6rem',
                            height: '3.2rem',
                        }}
                        disabled={isPortLocked(option)}
                    />
                </div>
            )
        })
    };

    return (
        <div className={styles.editor}>
            {renderBlock(title, renderSelected())}
            {renderBlock('Options:', renderSuggestions())}
        </div>
    )
}

CategoriesEditor.propTypes = {
    value: PropTypes.arrayOf(PropTypes.string).isRequired,
    onChange: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
    bodyBuilder: state.deployment.bodyBuilder,
})

export default connect(mapStateToProps)(CategoriesEditor)